export enum FORM_FIELDS {
  NAME = "name",
  LASTNAME = "lastName",
  RUT = "rut",
  EMAIL = "email",
  PHONE = "phone",
  MOTIVE = "motive",
  DESCRIPTION = "description",
}

// Usa FORM_FIELDS en lugar de strings directos para referenciar los campos
export interface FormValues {
  [FORM_FIELDS.NAME]: string;
  [FORM_FIELDS.LASTNAME]: string;
  [FORM_FIELDS.RUT]: string;
  [FORM_FIELDS.EMAIL]: string;
  [FORM_FIELDS.PHONE]: string;
  [FORM_FIELDS.MOTIVE]: string;
  [FORM_FIELDS.DESCRIPTION]: string;
}

export type ReCAPTCHARef = {
  getValue: () => void;
  reset: () => void;
  execute: () => void;
};
